import React from 'react';
import { useField } from 'react-final-form';
import { AudioTrackInfo } from 'components/organisms/gen-ai-audio-tool/GenAITool';
import { AudioCardSection } from '../audio-card-section/AudioCardSection';
import { tracks } from './constants';

export interface BackgroundMusicSectionProps {
  fieldName: string;
  handlePlayAudio: (
    /* eslint-disable no-unused-vars */
    trackInfo: Pick<AudioTrackInfo, 'id' | 'audioElement'> & {
      playFromStart?: boolean;
    },
  ) => void;
  handlePauseAudio: () => void;
  handleAudioEnded: () => void;
  currentAudioId: string;
}

export const BackgroundMusicSection: React.FC<BackgroundMusicSectionProps> = ({
  fieldName,
  handlePlayAudio,
  handlePauseAudio,
  handleAudioEnded,
  currentAudioId,
}) => {
  const {
    input: { value, onChange },
  } = useField(fieldName);

  const handleMusicChange = (idx: number) => {
    onChange(tracks[idx].audioId);
  };

  const selectedIndex = tracks.findIndex(track => track.audioId === value);

  return (
    <AudioCardSection
      type="music"
      selected={selectedIndex !== -1 ? selectedIndex : 0}
      onChange={handleMusicChange}
      audioTracks={tracks}
      title="Background music"
      caption="Explore more background music when you join Spotify Ads Manager."
      currentAudioId={currentAudioId}
      handlePlayAudio={handlePlayAudio}
      handlePauseAudio={handlePauseAudio}
      handleAudioEnded={handleAudioEnded}
    />
  );
};
